import { useLoaderStore } from '../context/LoaderContext';
import useApiEndpoints from '../context/useApiEndpoints';
import { LoaderDetailsType } from '../types/LoaderDetailsType';

export default () => {
    const { loaderState, dispatchLoaderAction } = useLoaderStore();
    const { apiEndpoints } = useApiEndpoints();

    const getLoaderDetailsType = (endpointUrl?: string | null) => {
        const endpointDetails = getEndpointDetails(endpointUrl);

        if (!endpointDetails) return;

        const loaderDetails: LoaderDetailsType = {
            message: endpointDetails.loaderMessage,
            endpoint: endpointDetails.url,
            isFeatureLoader: endpointDetails.isFeatureLoader,
            type: endpointDetails.type,
        };

        return loaderDetails;
    };

    const getEndpointDetails = (endpointUrl?: string | null) => {
        return findApiEndpoint(apiEndpoints, endpointUrl);
    };

    const findApiEndpoint = (apiEndpoints: any, endpointUrl?: string | null) => {
        const normalizedEndpointUrl = endpointUrl?.split('?')[0];
        if (!normalizedEndpointUrl) return;

        const key = Object.keys(apiEndpoints ?? {}).find((key) => apiEndpoints[key].url === normalizedEndpointUrl);
        if (key) return apiEndpoints[key];
    };

    const isActive = (l: LoaderDetailsType) => l.status === 'loading';

    const isLoadingType = (type: string) => loaderState.loaderDetails.find((l) => l.type && l.type === type && isActive(l));
    const isLoadingEndpoint = (endpoint: string) => loaderState.loaderDetails.find((l) => l.endpoint && l.endpoint === endpoint && isActive(l));

    const isLoadingTypeWithData = (type: string, property: string, value: any) => {
        return loaderState.loaderDetails.some((l) => {
            if (l.type && l.type === type && l.additionalLoaderData && isActive(l)) {
                if (l.additionalLoaderData[property] === value) {
                    return true;
                }
            }
        });
    };

    const getVisibleLoaderMessage = (onlyFullScreenLoaders?: boolean) => {
        const activeLoaders = loaderState.loaderDetails.filter(isActive);
        const details = onlyFullScreenLoaders ? activeLoaders.find((l) => !l.isFeatureLoader) : activeLoaders[0];
        return details?.message ?? undefined;
    };

    const getNonMutatingLoaders = () => loaderState.loaderDetails.filter((l) => !l.isMutating && !l.isFeatureLoader);

    const getMutatingLoaderMessage = () => {
        const mutating = loaderState.loaderDetails.find((l) => l.isMutating && l.status === 'loading');
        return mutating?.message ?? undefined;
    };

    const clearCompletedLoaders = () => {
        dispatchLoaderAction({ type: 'removeAllCompleted' });
    };

    return {
        isLoadingType,
        isLoadingEndpoint,
        isLoadingTypeWithData,
        getVisibleLoaderMessage,
        getLoaderDetailsType,
        getNonMutatingLoaders,
        getMutatingLoaderMessage,
        clearCompletedLoaders,
    };
};
